import { useEffect, useState } from "react";
import { Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { useCommonDataFindAllQuery, useMeasurementPurificationCreateMutation, useMeasurementPurificationFindAllQuery, useMeasurementPurificationUpdateMutation, useMeasurementPurificationDeleteMutation } from "store";
import * as Yup from "yup";
import { useFormik } from "formik";
import Spinners from "Components/Common/Spinner";
import { Link, useParams } from "react-router-dom";
import Switch from "react-switch";
import measurementSvg from "../../../assets/images/svg/measurement.svg"
import toastr from "toastr";
import DeleteModal from "Components/Common/DeleteModal";
import Flatpickr from "react-flatpickr";



const Measurement = () => {
  const { id } = useParams();
  const [isLoading, setLoading] = useState(true)
  const { data, error, isFetching } = useMeasurementPurificationFindAllQuery(`?purification_id=${id}`);
  const [measurementPurificationCreate, measurementPurificationCreateResult] = useMeasurementPurificationCreateMutation();
  const [measurementPurificationUpdate, measurementPurificationUpdateResult] = useMeasurementPurificationUpdateMutation();
  const [measurementPurificationDelete, measurementPurificationDeleteResult] = useMeasurementPurificationDeleteMutation();
  const [measurementPurification, setMeasurementPurification] = useState<any>();

  const [measurementList, setMeasurementList] = useState<any>();

  const [meaCount, setMeaCount] = useState<any>();

  const [is_used, setIs_usedBoolean] = useState<boolean>(false);
  const [is_clean, setIs_cleanBoolean] = useState<boolean>(false);
  const [is_newCreated, setIs_newCreated] = useState<boolean>(false);

  const [deleteModal, setDeleteModal] = useState(false)


  useEffect(() => {
    if (measurementPurification === undefined) {
      setLoading(true);
    } else {
      setLoading(false);
    }
    setMeasurementList(data?.data);
    setMeaCount(data?.data?.length)
    const tempIs_used = measurementPurification !== null ? measurementPurification?.is_used : false;
    const tempIs_clean = measurementPurification !== null ? measurementPurification?.is_clean : false;
    setIs_usedBoolean(tempIs_used)
    setIs_cleanBoolean(tempIs_clean)
  }, [id, data, measurementPurification])

  const onClickDelete = () => {
    setDeleteModal(true);
  };

  const handleDeletejob = () => {
    if (measurementPurification) {
      measurementPurificationDelete(measurementPurification.id);
      setDeleteModal(false);
    }
    setMeasurementPurification(null)
    setIs_usedBoolean(false)
    setIs_cleanBoolean(false)
    setIs_newCreated(true)
  };
  const validation: any = useFormik(
    {
      enableReinitialize: true,
      initialValues: {
        id: measurementPurification?.id,
        purification_id: measurementPurification?.purification_id,
        purification_code: measurementPurification?.purification_code,
        measure_date: measurementPurification?.measure_date,
        capacity_amountwater: measurementPurification?.capacity_amountwater,
        capacity_projectday: measurementPurification?.capacity_projectday,
        capacity_useday: measurementPurification?.capacity_useday,
        cleaning_type_mechanical: measurementPurification?.cleaning_type_mechanical,

        cleaning_type_biology: measurementPurification?.cleaning_type_biology,
        cleaning_type_chemistry: measurementPurification?.cleaning_type_chemistry,
        cleaning_type_purificationlevel: measurementPurification?.cleaning_type_purificationlevel,

        cleaning_type_surfacewater: measurementPurification?.cleaning_type_surfacewater,
        cleaning_type_ground: measurementPurification?.cleaning_type_ground,
        wastewater_liftingstation_num: measurementPurification?.wastewater_liftingstation_num,

        wastewater_liftingstation_capacity: measurementPurification?.wastewater_liftingstation_capacity,
        wastewater_liftingstation_brand: measurementPurification?.wastewater_liftingstation_brand,
        activatedsludge_pumping_num: measurementPurification?.activatedsludge_pumping_num,

        activatedsludge_pumping_capacity: measurementPurification?.activatedsludge_pumping_capacity,
        activatedsludge_pumping_brand: measurementPurification?.activatedsludge_pumping_brand,
        wastewater_reason: measurementPurification?.wastewater_reason,

        is_used: measurementPurification?.is_used,
        usage_information: measurementPurification?.usage_information,
        is_clean: measurementPurification?.is_clean,

        sanitary_requirements: measurementPurification?.sanitary_requirements,
        report_autor: measurementPurification?.report_autor,
        report_name: measurementPurification?.report_name,
        report_code: measurementPurification?.report_code,
      },
      validationSchema: Yup.object({
        purification_code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
        measure_date: Yup.date().typeError("Он сар өдөр оруулна уу").required("Утга оруулна уу !"),
        capacity_amountwater: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
        capacity_projectday: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
        capacity_useday: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
        cleaning_type_mechanical: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
        cleaning_type_biology: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),

        cleaning_type_chemistry: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
        cleaning_type_purificationlevel: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
        cleaning_type_surfacewater: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
        cleaning_type_ground: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
        wastewater_liftingstation_num: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),

        wastewater_liftingstation_capacity: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
        wastewater_liftingstation_brand: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
        activatedsludge_pumping_num: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
        activatedsludge_pumping_capacity: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),
        activatedsludge_pumping_brand: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
        wastewater_reason: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
        usage_information: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),

        sanitary_requirements: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
        report_autor: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
        report_name: Yup.string().typeError("Текст төрлийн утга оруулна уу").required("Утга оруулна уу !"),
        report_code: Yup.number().typeError("Тоон төрлийн утга оруулна уу").required("Утга оруулна уу !"),

      }),
      onSubmit: (values: any) => {

        if (is_newCreated === false) {
          const updateList = {
            id: measurementPurification?.id,
            purification_id: measurementPurification?.purification_id,
            purification_code: values?.purification_code,
            measure_date: values?.measure_date,
            capacity_amountwater: values?.capacity_amountwater,
            capacity_projectday: values?.capacity_projectday,
            capacity_useday: values?.capacity_useday,
            cleaning_type_mechanical: values?.cleaning_type_mechanical,
            cleaning_type_biology: values?.cleaning_type_biology,

            cleaning_type_chemistry: values?.cleaning_type_chemistry,
            cleaning_type_purificationlevel: values?.cleaning_type_purificationlevel,
            cleaning_type_surfacewater: values?.cleaning_type_surfacewater,
            cleaning_type_ground: values?.cleaning_type_ground,
            wastewater_liftingstation_num: values?.wastewater_liftingstation_num,
            wastewater_liftingstation_capacity: values?.wastewater_liftingstation_capacity,
            wastewater_liftingstation_brand: values?.wastewater_liftingstation_brand,
            activatedsludge_pumping_num: values?.activatedsludge_pumping_num,
            activatedsludge_pumping_capacity: values?.activatedsludge_pumping_capacity,
            activatedsludge_pumping_brand: values?.activatedsludge_pumping_brand,
            wastewater_reason: values?.wastewater_reason,
            is_used: values?.is_used,
            usage_information: values?.usage_information,
            is_clean: values?.is_clean,

            sanitary_requirements: values?.sanitary_requirements,
            report_autor: values?.report_autor,
            report_name: values?.report_name,
            report_code: values?.report_code,

          }

          measurementPurificationUpdate(updateList)
            .unwrap()
            .then((response) => {
              toastr.success("Мэдээлэл амжилттай засагдлаа!", "Амжилттай");
            })
            .catch((error) => {
              toastr.error("Амжилтгүй!", "Амжилтгүй");
            })

        } else {
          const newList = {
            purification_id: id,
            purification_code: values["purification_code"],
            measure_date: values["measure_date"],
            capacity_amountwater: values["capacity_amountwater"],
            capacity_projectday: values["capacity_projectday"],
            capacity_useday: values["capacity_useday"],
            cleaning_type_mechanical: values["cleaning_type_mechanical"],
            cleaning_type_biology: values["cleaning_type_biology"],

            cleaning_type_chemistry: values["cleaning_type_chemistry"],
            cleaning_type_purificationlevel: values["cleaning_type_purificationlevel"],
            cleaning_type_surfacewater: values["cleaning_type_surfacewater"],
            cleaning_type_ground: values["cleaning_type_ground"],
            wastewater_liftingstation_num: values["wastewater_liftingstation_num"],
            wastewater_liftingstation_capacity: values["wastewater_liftingstation_capacity"],
            wastewater_liftingstation_brand: values["wastewater_liftingstation_brand"],
            activatedsludge_pumping_num: values["activatedsludge_pumping_num"],
            activatedsludge_pumping_capacity: values["activatedsludge_pumping_capacity"],
            activatedsludge_pumping_brand: values["activatedsludge_pumping_brand"],
            wastewater_reason: values["wastewater_reason"],
            is_used: Boolean(is_used),
            usage_information: values["usage_information"],
            is_clean: Boolean(is_clean),

            sanitary_requirements: values["sanitary_requirements"],
            report_autor: values["report_autor"],
            report_name: values["report_name"],
            report_code: values["report_code"],


          };

          measurementPurificationCreate(newList)
            .unwrap()
            .then((response) => {
              toastr.success("Мэдээлэл амжилттай үүслээ!", "Амжилттай");
            })
            .catch((error) => {
              toastr.error("Амжилтгүй!", "Амжилтгүй");
            })
        }
        // validation.resetForm();
      },
    });

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Үгүй
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2
        }}
      >
        {" "}
        Тийм
      </div>
    );
  };

  return (

    <>


      <Row>
        <Col lg={12}>
          <div className="d-flex align-items-center mb-3">
            <img src={measurementSvg} alt="" height="50" />
            <div className="flex-grow-1 ms-3">
              <h5 className="fw-semibold">Мэдээлэл</h5>
              <ul className="list-unstyled hstack gap-2 mb-0">
                <li>
                  <i className="mdi mdi-table-row-height"></i>{" "}
                  <span className="text-muted fw-semibold">
                    Нийт: {meaCount}
                  </span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              disabled={is_newCreated === true ? true : false}
              className="btn btn-success  btn-label"
              onClick={() => {
                validation.resetForm();
                setMeasurementPurification(null);
                setIs_cleanBoolean(false);
                setIs_usedBoolean(false);
                setIs_newCreated(true);
              }}
            >
              <i className="mdi mdi-file-plus-outline label-icon"></i>
              Шинээр нэмэх
            </button>
            {
              is_newCreated === false && measurementList !== null ?
                <button
                  type="button"
                  onClick={(event: any) => {
                    event.preventDefault();
                    onClickDelete();
                  }}
                  className="btn btn-danger  btn-label"
                >
                  <i className="mdi mdi-delete-empty-outline label-icon"></i> Устгах
                </button>
                : ''
            }
          </div>
        </Col>
      </Row>
      <Row>
        <DeleteModal
          deleteName={measurementList?.purification_code}
          show={deleteModal}
          onDeleteClick={handleDeletejob}
          onCloseClick={() => setDeleteModal(false)}
        />
        <Col lg={3}>
          <ul className="verti-timeline list-unstyled">
            {measurementList?.map((item, index) => (
              <li className="event-list active">
                <div className="event-timeline-dot">
                  <i className="bx bxs-right-arrow-circle font-size-18 bx-fade-right" />
                </div>
                <div className="flex-shrink-0 d-flex">
                  <div key={index} className="d-flex mb-3">
                    <div className="me-3">
                      <h5 className="font-size-14">
                        {item?.created_at.split("T")[0]}
                        <i className="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2" />
                      </h5>
                    </div>
                    <div className="flex-grow-1">
                      <div>
                        <Link
                          to="#"
                          className="cursor fw-semibold"
                          onClick={() => {
                            setIs_newCreated(false)
                            setMeasurementPurification(item)
                          }}
                        >
                          {item?.measure_date}
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Col>
        <Col lg={9}>
          {
            isLoading ? <Spinners setLoading={setLoading} sCustomTop={'120px'} /> :
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <Row>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Код </Label>
                      <Input
                        name="purification_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.purification_code || ""}
                        invalid={
                          validation.touched.purification_code &&
                            validation.errors.purification_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.purification_code &&
                        validation.errors.purification_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.purification_code}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Төслийн хоног </Label>
                      <Input
                        name="capacity_projectday"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.capacity_projectday || ""}
                        invalid={
                          validation.touched.capacity_projectday &&
                            validation.errors.capacity_projectday
                            ? true
                            : false
                        }
                      />
                      {validation.touched.capacity_projectday &&
                        validation.errors.capacity_projectday ? (
                        <FormFeedback type="invalid">
                          {validation.errors.capacity_projectday}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Биологи </Label>
                      <Input
                        name="cleaning_type_biology"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.cleaning_type_biology || ""}
                        invalid={
                          validation.touched.cleaning_type_biology &&
                            validation.errors.cleaning_type_biology
                            ? true
                            : false
                        }
                      />
                      {validation.touched.cleaning_type_biology &&
                        validation.errors.cleaning_type_biology ? (
                        <FormFeedback type="invalid">
                          {validation.errors.cleaning_type_biology}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">  Цэвэрлэсэн бохир усаа гадаргын усанд хаядаг  </Label>
                      <Input
                        name="cleaning_type_surfacewater"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.cleaning_type_surfacewater || ""}
                        invalid={
                          validation.touched.cleaning_type_surfacewater &&
                            validation.errors.cleaning_type_surfacewater
                            ? true
                            : false
                        }
                      />
                      {validation.touched.cleaning_type_surfacewater &&
                        validation.errors.cleaning_type_surfacewater ? (
                        <FormFeedback type="invalid">
                          {validation.errors.cleaning_type_surfacewater}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Бохир ус өргөх станци-Хүчин чадал</Label>
                      <Input
                        name="wastewater_liftingstation_capacity"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.wastewater_liftingstation_capacity || ""}
                        invalid={
                          validation.touched.wastewater_liftingstation_capacity &&
                            validation.errors.wastewater_liftingstation_capacity
                            ? true
                            : false
                        }
                      />
                      {validation.touched.wastewater_liftingstation_capacity &&
                        validation.errors.wastewater_liftingstation_capacity ? (
                        <FormFeedback type="invalid">
                          {validation.errors.wastewater_liftingstation_capacity}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Идэвхит лагийн насосны станци - Хүчин чадал</Label>
                      <Input
                        name="activatedsludge_pumping_capacity"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.activatedsludge_pumping_capacity || ""}
                        invalid={
                          validation.touched.activatedsludge_pumping_capacity &&
                            validation.errors.activatedsludge_pumping_capacity
                            ? true
                            : false
                        }
                      />
                      {validation.touched.activatedsludge_pumping_capacity &&
                        validation.errors.activatedsludge_pumping_capacity ? (
                        <FormFeedback type="invalid">
                          {validation.errors.activatedsludge_pumping_capacity}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглаж байгаа эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setIs_usedBoolean(!is_used);
                        }}
                        checked={is_used}
                      />
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Ариун цэвэр, эрүүл ахуйн шаардлага хангалт </Label>
                      <Input
                        name="sanitary_requirements"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.sanitary_requirements || ""}
                        invalid={
                          validation.touched.sanitary_requirements &&
                            validation.errors.sanitary_requirements
                            ? true
                            : false
                        }
                      />
                      {validation.touched.sanitary_requirements &&
                        validation.errors.sanitary_requirements ? (
                        <FormFeedback type="invalid">
                          {validation.errors.sanitary_requirements}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Нэр  </Label>
                      <Input
                        name="report_code"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_code || ""}
                        invalid={
                          validation.touched.report_code &&
                            validation.errors.report_code
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_code &&
                        validation.errors.report_code ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_code}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хэмжилт хийсэн огноо </Label>
                      <Flatpickr
                        className="form-control d-block"
                        placeholder="Огноо"
                        name="measure_date"
                        value={validation.values.measure_date}
                        onChange={(selectDate: Date[]) => {
                          if (selectDate[0]) {
                            const localDate = new Date(selectDate[0].getTime() - selectDate[0].getTimezoneOffset() * 60000)
                              .toISOString()
                              .split('T')[0];
                            validation.setFieldValue('measure_date', localDate);
                          }
                        }}
                        options={{
                          altInput: true,
                          altFormat: "Y-m-d",
                          dateFormat: "Y-m-d",
                          enableTime: false,
                        }}
                      />
                      {validation.touched.measure_date &&
                        validation.errors.measure_date ? (
                        <FormFeedback type="invalid">
                          {validation.errors.measure_date}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Ашиглалтын хоног </Label>
                      <Input
                        name="capacity_useday"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.capacity_useday || ""}
                        invalid={
                          validation.touched.capacity_useday &&
                            validation.errors.capacity_useday
                            ? true
                            : false
                        }
                      />
                      {validation.touched.capacity_useday &&
                        validation.errors.capacity_useday ? (
                        <FormFeedback type="invalid">
                          {validation.errors.capacity_useday}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Хими </Label>
                      <Input
                        name="cleaning_type_chemistry"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.cleaning_type_chemistry || ""}
                        invalid={
                          validation.touched.cleaning_type_chemistry &&
                            validation.errors.cleaning_type_chemistry
                            ? true
                            : false
                        }
                      />
                      {validation.touched.cleaning_type_chemistry &&
                        validation.errors.cleaning_type_chemistry ? (
                        <FormFeedback type="invalid">
                          {validation.errors.cleaning_type_chemistry}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">  Хөрсөнд хаядаг хоног </Label>
                      <Input
                        name="cleaning_type_ground"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.cleaning_type_ground || ""}
                        invalid={
                          validation.touched.cleaning_type_ground &&
                            validation.errors.cleaning_type_ground
                            ? true
                            : false
                        }
                      />
                      {validation.touched.cleaning_type_ground &&
                        validation.errors.cleaning_type_ground ? (
                        <FormFeedback type="invalid">
                          {validation.errors.cleaning_type_ground}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">  Насосны марк, төрөл  </Label>
                      <Input
                        name="wastewater_liftingstation_brand"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.wastewater_liftingstation_brand || ""}
                        invalid={
                          validation.touched.wastewater_liftingstation_brand &&
                            validation.errors.wastewater_liftingstation_brand
                            ? true
                            : false
                        }
                      />
                      {validation.touched.wastewater_liftingstation_brand &&
                        validation.errors.wastewater_liftingstation_brand ? (
                        <FormFeedback type="invalid">
                          {validation.errors.wastewater_liftingstation_brand}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">  Насосны марк, төрөл  </Label>
                      <Input
                        name="activatedsludge_pumping_brand"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.activatedsludge_pumping_brand || ""}
                        invalid={
                          validation.touched.activatedsludge_pumping_brand &&
                            validation.errors.activatedsludge_pumping_brand
                            ? true
                            : false
                        }
                      />
                      {validation.touched.activatedsludge_pumping_brand &&
                        validation.errors.activatedsludge_pumping_brand ? (
                        <FormFeedback type="invalid">
                          {validation.errors.activatedsludge_pumping_brand}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold">  Насосны марк, төрөл  </Label>
                      <Input
                        name="usage_information"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.usage_information || ""}
                        invalid={
                          validation.touched.usage_information &&
                            validation.errors.usage_information
                            ? true
                            : false
                        }
                      />
                      {validation.touched.usage_information &&
                        validation.errors.usage_information ? (
                        <FormFeedback type="invalid">
                          {validation.errors.usage_information}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Бүртгэл үйлдсэн ажилтан </Label>
                      <Input
                        name="report_autor"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_autor || ""}
                        invalid={
                          validation.touched.report_autor &&
                            validation.errors.report_autor
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_autor &&
                        validation.errors.report_autor ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_autor}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg={4}>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Цэвэрлэх усны хэмжээ </Label>
                      <Input
                        name="capacity_amountwater"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.capacity_amountwater || ""}
                        invalid={
                          validation.touched.capacity_amountwater &&
                            validation.errors.capacity_amountwater
                            ? true
                            : false
                        }
                      />
                      {validation.touched.capacity_amountwater &&
                        validation.errors.capacity_amountwater ? (
                        <FormFeedback type="invalid">
                          {validation.errors.capacity_amountwater}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Цэвэрлэгээний төрөл - Механик </Label>
                      <Input
                        name="cleaning_type_mechanical"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.cleaning_type_mechanical || ""}
                        invalid={
                          validation.touched.cleaning_type_mechanical &&
                            validation.errors.cleaning_type_mechanical
                            ? true
                            : false
                        }
                      />
                      {validation.touched.cleaning_type_mechanical &&
                        validation.errors.cleaning_type_mechanical ? (
                        <FormFeedback type="invalid">
                          {validation.errors.cleaning_type_mechanical}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Цэвэршүүлэлтийн түвшин, %  </Label>
                      <Input
                        name="cleaning_type_purificationlevel"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.cleaning_type_purificationlevel || ""}
                        invalid={
                          validation.touched.cleaning_type_purificationlevel &&
                            validation.errors.cleaning_type_purificationlevel
                            ? true
                            : false
                        }
                      />
                      {validation.touched.cleaning_type_purificationlevel &&
                        validation.errors.cleaning_type_purificationlevel ? (
                        <FormFeedback type="invalid">
                          {validation.errors.cleaning_type_purificationlevel}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Бохир ус өргөх станци -  Тоо </Label>
                      <Input
                        name="wastewater_liftingstation_num"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.wastewater_liftingstation_num || ""}
                        invalid={
                          validation.touched.wastewater_liftingstation_num &&
                            validation.errors.wastewater_liftingstation_num
                            ? true
                            : false
                        }
                      />
                      {validation.touched.wastewater_liftingstation_num &&
                        validation.errors.wastewater_liftingstation_num ? (
                        <FormFeedback type="invalid">
                          {validation.errors.wastewater_liftingstation_num}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Идэвхит лагийн насосны станци - Тоо </Label>
                      <Input
                        name="activatedsludge_pumping_num"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.activatedsludge_pumping_num || ""}
                        invalid={
                          validation.touched.activatedsludge_pumping_num &&
                            validation.errors.activatedsludge_pumping_num
                            ? true
                            : false
                        }
                      />
                      {validation.touched.activatedsludge_pumping_num &&
                        validation.errors.activatedsludge_pumping_num ? (
                        <FormFeedback type="invalid">
                          {validation.errors.activatedsludge_pumping_num}
                        </FormFeedback>
                      ) : null}
                    </div>
                    <div className="mb-3">
                      <Label className="fw-semibold"> Бохир усыг дутуу цэвэрлэж байгаа шалтгаан  </Label>
                      <Input
                        name="wastewater_reason"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.wastewater_reason || ""}
                        invalid={
                          validation.touched.wastewater_reason &&
                            validation.errors.wastewater_reason
                            ? true
                            : false
                        }
                      />
                      {validation.touched.wastewater_reason &&
                        validation.errors.wastewater_reason ? (
                        <FormFeedback type="invalid">
                          {validation.errors.wastewater_reason}
                        </FormFeedback>
                      ) : null}
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Ариун цэвэрийн шаардлага хангасан эсэх </Label> <br />
                      <Switch
                        uncheckedIcon={<Offsymbol />}
                        checkedIcon={<OnSymbol />}
                        className="me-1 mb-sm-8 mb-2 ms-3"
                        onColor="#626ed4"
                        onChange={() => {
                          setIs_cleanBoolean(!is_clean);
                        }}
                        checked={is_clean}
                      />
                    </div>

                    <div className="mb-3">
                      <Label className="fw-semibold"> Бүртгэл үйлдсэн хүний албан тушаал </Label>
                      <Input
                        name="report_name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.report_name || ""}
                        invalid={
                          validation.touched.report_name &&
                            validation.errors.report_name
                            ? true
                            : false
                        }
                      />
                      {validation.touched.report_name &&
                        validation.errors.report_name ? (
                        <FormFeedback type="invalid">
                          {validation.errors.report_name}
                        </FormFeedback>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg={12} className="d-flex justify-content-center mt-3">
                    <button type="submit" className="btn btn-primary"> Хадгалах </button>
                  </Col>
                </Row>
              </Form>
          }
        </Col>
      </Row>
    </>
  )
}

export default Measurement;